"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.TabsContext = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var tabs_1 = require("@reach/tabs");

var react_1 = tslib_1.__importStar(require("react"));

exports.TabsContext = react_1.createContext({
  pattern: 'main'
});

var Tabs = function Tabs(_a) {
  var className = _a.className,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'main' : _b,
      children = _a.children,
      __UIScope = _a.__UIScope,
      restProps = tslib_1.__rest(_a, ["className", "pattern", "children", "__UIScope"]);

  var context = {
    pattern: pattern
  };
  var rootClasses = ui_helper_deep_branding_1.useEscapeClasses({
    block: Tabs.name,
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(tabs_1.Tabs, tslib_1.__assign({
    className: rootClasses
  }, restProps), react_1.default.createElement(exports.TabsContext.Provider, {
    value: context
  }, children));
};

exports.Tabs = Tabs;